import { useAssignedClientSelection } from "../../../hooks";
import { COIAdmin } from "./COIAdmin";

export const COIClient = () => {
  const { clientOptions, selectedClientId, setSelectedClientId } =
    useAssignedClientSelection();

  return (
    <COIAdmin
      clientMode
      assignedClientOptions={clientOptions}
      assignedClientId={selectedClientId}
      onAssignedClientChange={setSelectedClientId}
    />
  );
};
